import { CrudPlaceholderInputModel } from "./crudPlaceholderInputModel";

export const CrudPlaceholderInput = ({ name }: CrudPlaceholderInputModel) => {
  return <span key={name} data-name={name} />;
};
